<template>
   <div class="simulateur-vue simulateur-capacite-emprunt-vue">
        <div class="input-data-container">
            
            <div class="row" >
                <div class="columns medium-12 small-12 " > 
                    <div class="fields-container small">
                        <div class="field-group-title">Vos revenus</div>
                        <div class="form-input">
                            <label>
                                <cleave v-model="revenusMensuels" :options="cleaveOptionsDecimal"></cleave>
                                <span class="placeholder">Revenus mensuels</span>
                                <span class="unit">€</span>
                            </label>
                        </div>
                        <div class="form-input">
                            <label>
                                <cleave v-model="revenusLocatifs" :options="cleaveOptionsDecimal"></cleave>
                                <span class="placeholder">Revenus locatifs, financiers</span>
                                <span class="unit">€</span>
                            </label>
                        </div>
                        <div class="form-input">
                            <label>
                                <cleave v-model="caisseAllocation" :options="cleaveOptionsDecimal"></cleave>
                                <span class="placeholder">Caisse d'allocation</span>
                                <span class="unit">€</span>
                            </label>
                        </div>
                        <div class="form-input">
                            <label>
                                <cleave v-model="aideLogement" :options="cleaveOptionsDecimal"></cleave>
                                <span class="placeholder">Aide au logement</span>
                                <span class="unit">€</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="columns medium-12 small-12 " > 
                    <div class="fields-container small">
                        <div class="field-group-title">Vos charges</div>
                        <div class="form-input">
                            <label>
                                <cleave v-model="pensionAlimentaire" :options="cleaveOptionsDecimal"></cleave>
                                <span class="placeholder">Pensions alimentaire versées</span>
                                <span class="unit">€</span>
                            </label>
                        </div>
                        <div class="form-input">
                            <label>
                                <cleave v-model="autres" :options="cleaveOptionsDecimal"></cleave>
                                <span class="placeholder">Autres</span>
                                <span class="unit">€</span>
                            </label>
                        </div>    
                    
                    </div>
                </div>
            
                <div class="columns medium-12 small-12 " > 
                    <div class="fields-container small">
                        <div class="field-group-title">Votre prêt</div>
                    
                    
                        <div class="form-input result">
                            <label>
                                <select v-model="duree"> 
                                    <option :value="taux.duree" v-for="taux in tauxSimulateurs">Sur {{taux.duree}} ans (Taux annuel à {{taux.taux.toFixed(2)}}%)</option>
                                </select>
                                <span class="placeholder">Durée et taux de votre prêt</span>
                            </label>
                        </div>
                        <div class="form-input">
                            <label>
                                <cleave v-model="apport" :options="cleaveOptionsDecimal"></cleave>
                                <span class="placeholder">Apport</span>
                                <span class="unit">€</span>
                            </label>
                        </div>   
                            
                    
                        <!-- <div class="submit-block" style="margin-top: 60px;">
                            <a @click="calculate()" class="submit block cp-button green rounded">Calculer</a>
                        </div> -->
                    
                    </div>
                </div> 
            </div>
        </div>
        <div class="result-container">
            <div class="result-title">Résultats de votre simulation</div>
            <div v-if="error" class="flash-error">{{error}}</div>
            <div class="row">
                <div class="columns medium-12 small-12">
                    
                    <div v-if="!error" class="fields-container "> 
                        <div class="field-group-title">Votre capacité d'emprunt</div>
                        <div class="field-group-info">Votre capacité d'emprunt est calculé selon un taux d'endettement de <span>{{tauxEndettement}}%</span></div>
                        <div class="form-input result">
                            <label>
                                <cleave disabled v-model="mensualite" :options="cleaveOptionsDecimal"></cleave>
                            
                                <span class="placeholder">Vos mensualités</span>
                                <span class="unit">€/mois</span>
                            </label>
                        </div>
                        <div class="form-input result">
                            <label>
                                <cleave disabled v-model="capaciteEmprunt" :options="cleaveOptionsDecimal"></cleave>
                                <span class="placeholder">Capacité de votre emprunt</span>
                                <span class="unit">€</span>
                            </label>
                        </div>
                        <div v-if="apport > 0" class="form-input result">
                            <label>
                                <cleave disabled v-model="capaciteProjet" :options="cleaveOptionsDecimal"></cleave>
                                <span class="placeholder">Capacité de votre projet</span>
                                <span class="unit">€</span>
                            </label>
                        </div>
                        <div class="form-input result">
                            <label>
                                <cleave disabled v-model="coutCredit" :options="cleaveOptionsDecimal"></cleave>
                                <span class="placeholder">Intérêts de l'emprunt</span>
                                <span class="unit">€</span>
                            </label>
                        </div>
                        <div class="form-input result">
                            <label>
                                <cleave disabled v-model="coutTotal" :options="cleaveOptionsDecimal"></cleave>
                                <span class="placeholder">Coût de l'emprunt avec les Intérêts</span>
                                <span class="unit">€</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  
    </div>
</template>

<script>
export default {
  mounted () {
    
    this.tauxSimulateurs = window.tauxSimulateurs
    this.tauxEndettement = parseFloat(window.tauxEndettement)
    let tmpDuree = this.tauxSimulateurs[0]
    if(tmpDuree) {
        this.duree = tmpDuree.duree
    }
  },
  data () {
    return {
      
      duree: null,
      tauxEndettement: 0,
      tauxSimulateurs: [],
      revenusMensuels: null,
      revenusLocatifs: null,
      caisseAllocation: null,
      aideLogement: null,
      pensionAlimentaire: null,
      autres: null,
      apport: null,
      cleaveOptionsDecimal: {
          numeral: true,
          numeralDecimalMark: ',',
          delimiter: ' '
      },
      cleaveOptionsInteger: {
          numeral: true,
          numeralDecimalMark: '',
          delimiter: ' '
      },
    }
  },
  computed: {
    error () {
        if(this.provisionPositive < this.provisionNegative) {
            return "Attention, vous avez indiqué avoir plus de charges que de revenus ! Vérifiez les informations saisies"
        }
        return null;
    },
    coutCredit () {
       return this.coutTotal - this.capaciteEmprunt
    },
    capaciteProjet () {
       return this.capaciteEmprunt + parseFloat(this.apport === null ? 0 : this.apport)
    },
    capaciteEmprunt () {
       return (((1 -  Math.pow( 1 + this.tauxMensuelSousUn  , -this.dureeCreditEnMois)) * this.mensualite) /  this.tauxMensuelSousUn)
    },
    coutTotal () {
       return (this.dureeCreditEnMois * this.mensualite) 
    },
    provisionPositive () {
        let revenuMensuels = parseFloat(this.revenusMensuels === null ? 0 : this.revenusMensuels);
        let revenusLocatifs = parseFloat(this.revenusLocatifs === null ? 0 : this.revenusLocatifs);
        let aideLogement = parseFloat(this.aideLogement === null ? 0 : this.aideLogement);
        let caisseAllocation = parseFloat(this.caisseAllocation === null ? 0 : this.caisseAllocation);
        return revenuMensuels + revenusLocatifs + aideLogement + caisseAllocation
    },
    provisionNegative () {
        let pensionAlimentaire = parseFloat( this.pensionAlimentaire === null ? 0 : this.pensionAlimentaire);
        let autres = parseFloat(this.autres === null ? 0 : this.autres);
        return pensionAlimentaire + autres
    },
    provisionMensuel () {
        return this.provisionPositive - this.provisionNegative
    },
    mensualite () {
        return this.provisionMensuel * this.tauxEndettementSousUn 
    },
    tauxEndettementSousUn () {
        return parseFloat(this.tauxEndettement) / 100
    },
    dureeCreditEnMois () {
      return this.duree * 12
    },
    tauxAnnuel () {
        let item = this.tauxSimulateurs.find((item) => {
            if(item.duree === this.duree) {
                return item
            }
        })
        if(item) {
            return item.taux
        }
    },
    tauxAnnuelSousUn () {
      return this.tauxAnnuel / 100
    },
    tauxMensuelSousUn () {
      return this.tauxAnnuelSousUn / 12
    },
  },
  methods: {
    calculate () {
      
    }

  }
}
</script>

<style lang="scss">

</style>




// WEBPACK FOOTER //
// src/js/vue/components/SimulateurCapaciteEmprunt.vue